'use strict';

var React = require('react');

var SvgClipboardCheckFilledIcon = function SvgClipboardCheckFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.5 4.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-3-1.5a2 2 0 0 0-1.985 1.75h-.265a2.25 2.25 0 0 0-2.25 2.25v7.75a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.75a2.25 2.25 0 0 0-2.25-2.25h-.265a2 2 0 0 0-1.985-1.75h-3Zm4.78 7.28a.75.75 0 1 0-1.06-1.06l-2.97 2.97-1.22-1.22a.75.75 0 0 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0l3.5-3.5Z"
  }));
};
SvgClipboardCheckFilledIcon.displayName = "ClipboardCheckFilledIcon";

exports.SvgClipboardCheckFilledIcon = SvgClipboardCheckFilledIcon;
